// WhatsappRedirect.jsx
import { useEffect } from "react";

export default function WhatsappRedirect() {
  useEffect(() => {
    window.location.href = "https://wa.me/962791008716"; // Replace with your WhatsApp number
  }, []);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2>Redirecting you to WhatsApp...</h2>
      <p>
        If you are not redirected,{" "}
        <a href="https://wa.me/962791008716">click here</a>.
      </p>
    </div>
  );
}
